export default __webpack_public_path__ + "images/Armenian.d75f84.jpg";